// zod compiles a schema on its first parse, so a definition built anew on every access would be compiled again for every node.
export function lazyDefinition<Definition>(create: () => Definition): () => Definition {
    let definition: Definition | undefined
    return () => (definition ??= create())
}
